define('responsive-gameday/views/Monitor/Events/ViewModelUpdateEvents',{
    UPDATE_BOXSCORE: "updateBoxscoreView",
    UPDATE_ATBAT: "updateAtbatViews",
    UPDATE_ATBAT_W_LINESCORE: "updateAtbatWLinescore",
    //
    UPDATE_CHYRON: "updateChyron",
    UPDATE_CHYRON_PREGAME: "updateChyronPregame",
    UPDATE_CHYRON_INNING: "updateChyronInning",
    UPDATE_CHYRON_MID_INNING: "updateChyronMidInning",
    UPDATE_CHYRON_DELAY: "updateChyronDelay",
    UPDATE_CHYRON_FINAL: "updateChyronFinal",
    UPDATE_CHYRON_OTHER: "updateChyronOther",
    UPDATE_CHYRON_BSO: "updateChyronBSO",
     //
    UPDATE_PANELTABS: "updatePanelTabs",
    UPDATE_GAMESTATE: "updateGameState",
    UPDATE_VIDEO_CONTENT_VISIBILITY: "updateVideoContentVisibility",
    //
    UPDATE_INNING: "updateInningsViews",
    UPDATE_SCORES: "updateScoringPlaysView",
    UPDATE_VIDEO: "updateVideoView",
    UPDATE_HOTCOLD_ZONES: "updateHotColdZoneViews",
    UPDATE_PITCHBYPITCH: "updatePitchByPitchViews",
    UPDATE_PLAYBYPLAY: "updatePlayByPlayViews",
    UPDATE_PITCHFX: "updatePitchFXViews",
    UPDATE_MATCHUP: "updateMatchupViews",
    //
    UPDATE_FIELD_VIEW: "updateFieldView",
    //
    //
    UPDATE_GAMECENTER: "updateGamecenter",
    UPDATE_WRAPUP: "updateWrapup",
    UPDATE_TEAM_MATCHUP_SUMMARY: "updateTeamMatchupSummary",
    UPDATE_PREGAME: "updatePregame",
    //
    REQUEST_BOX_DATA: "requestBoxData",
    REQUEST_INNING_DATA : "requestInningData",
    REQUEST_CHYRON_DATA: "requestChyronData",
    REQUEST_PLAYBYPLAY_DATA: "requestPlayByPlayData",
    REQUEST_SCORES_DATA: "requestScoresData",
    REQUEST_PITCHFX_DATA: "requestPitchFXData",    
    REQUEST_PITCHBYPITCH_DATA: "requestPitchByPitchData",
    REQUEST_STADIUM_DATA: "requestStadiumData",
    REQUEST_MATCHUP_DATA: "requestMatchupData",
    REQUEST_FIELD_VIEW_DATA: "requestFieldViewData",
    REQUEST_VIDEO_DATA: "requestVideoData",
    REQUEST_PANELTABS: "requestPanelTabs",
    REQUEST_GAMESTATE: "requestGameState",
    REQUEST_VIDEO_CONTENT_VISIBILITY: "requestVideoContentVisibility",
	REQUEST_VIDEO_AD_STATUS: "requestVideoAdStatus",
    REQUEST_GAMECENTER: "requestGamecenter",
    REQUEST_PREGAME_DATA: "requestPregameData",
    REQUEST_WRAPUP_DATA: "requestWraupData",
    REQUEST_TEAM_MATCHUP_SUMMARY: "requestMatchupSummary"
});
